import ClassNames from "classnames";
import { FunctionComponent } from "react";
import { getActiveSite } from "../selectors/sites.js";
import { duplicateColorScheme } from "../slices/colorSchemes.js";
import { useAppDispatch, useAppSelector } from "../store/hooks.js";
import styles from "../stylesheets/components/color-scheme-selection.module.css";
import ColorScheme from "./ColorScheme.js";

interface Props {
  siteId: string;
  activeId: string | null;
  onSelection: (id: string) => void;
  onEdit: (id: string) => void;
  onSetDefault: () => void;
}

const ColorSchemeSelection: FunctionComponent<Props> = ({
  activeId,
  siteId,
  onSelection,
  onEdit,
  onSetDefault,
}) => {
  const dispatch = useAppDispatch();
  const schemes = useAppSelector((state) => state.colorSchemes.schemes);
  const defaultSchemeId = useAppSelector((state) => {
    const { colorSchemeId } = getActiveSite(state.sites);
    return colorSchemeId;
  });

  const schemeIds = Object.keys(schemes);
  const schemesExist = !!schemeIds.length;

  return (
    <div className={ClassNames(styles.ColorSchemeSelection, "Form__Field")}>
      <div className="Form__Content Form__Content--column">
        {schemeIds.map((id) => {
          const scheme = schemes[id];
          if (!scheme) {
            return null;
          }

          return (
            <ColorScheme
              key={id}
              id={id}
              scheme={scheme}
              isActive={activeId === id}
              isDefaultScheme={defaultSchemeId === id}
              onSelection={onSelection}
              onDuplicate={() => dispatch(duplicateColorScheme(siteId, id))}
              onEdit={onEdit}
              className={styles.ColorSchemeSelection__ColorScheme}
            />
          );
        })}
        {schemesExist && (
          <button
            className="Btn Form__Content__Button"
            type="button"
            onClick={() => onSetDefault()}
          >
            Auf Standard zurücksetzen
          </button>
        )}
      </div>
      <div className="Form__Label">
        <label>Farbschemen</label>
      </div>
    </div>
  );
};

export default ColorSchemeSelection;
